// extracted by mini-css-extract-plugin
module.exports = {"termsBase":"styles_termsBase__8IN_0 system_textBodyM__ZzPjG"};